import { useSlice } from "./useSlice";

export function useFeatures(callback) {
  if (callback) {
    return callback(useSlice("myStatus").features || {});
  } else {
    return useSlice("myStatus").features || {};
  }
}
